import { render, staticRenderFns } from "./Yapay.vue?vue&type=template&id=d054d1f6&"
import script from "./Yapay.vue?vue&type=script&lang=js&"
export * from "./Yapay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports